<div class="row align-top gutters">
  <div class="col-md-12">
    <div class="construction-subheaders">
      Construction Details
    </div>
  </div>
</div>

@if (permissions.creawebConstructionFieldPermissions._edit) {
  <div class="row align-top gutters">
    <div class="col-md-12">
      <button class="edit-button" mat-raised-button (click)="toggleEditMode()">
        @if (!isEditMode) {
          <span>Edit</span>
        }
        @if (isEditMode) {
          <span>Save</span>
        }
      </button>
    </div>
  </div>
}

<div class="row align-top gutters top-padding">
  <div class="col-md-6">
    <div class="mat-elevation-z8">
      <table mat-table class="stripped-table" #constructionTable
        [dataSource]="dataSource">

        <!-- Field Column -->
        <ng-container matColumnDef="field">
          <th mat-header-cell *matHeaderCellDef> Field </th>
          <td mat-cell class="name-column" *matCellDef="let row">
            {{row.field}}
          </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Value </th>
          <td mat-cell *matCellDef="let row">
            @if (!isEditMode) {
              <span>{{row.value}}</span>
            }
            @if (isEditMode && row.type === 'number') {
              <mat-form-field>
                <mat-label>Probable Maximum Loss</mat-label>
                <input matInput placeholder="Enter Probable Maximum Loss" [(ngModel)]="newLossValue">
              </mat-form-field>
            }
            @if (isEditMode && row.type !== 'number') {
              <mat-form-field>
                <mat-label>Environmental Conditions</mat-label>
                <mat-select [(value)]="newConditions">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                  <mat-option [value]="'n/a'">N/A</mat-option>
                </mat-select>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
      </table>
    </div>
  </div>
</div>

<div class="row align-top gutters">
  <div class="col-md-6">
    <div [ngClass]="permissions.creawebConstructionFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebConstructionFieldPermissions._edit) {
        <span></span>
      }
      Construction Review Findings
      @if (permissions.creawebConstructionFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleReviewEditMode()">
            @if (!reviewEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (reviewEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebConstructionFieldPermissions._edit || !reviewEditMode) {
      <div>
        @if (reviewFindings !== '') {
          <div class="notes-read-only">{{reviewFindings}}</div>
        }
        @if (reviewFindings === '') {
          <em>There are no Construction Review Findings for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebConstructionFieldPermissions._edit && reviewEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Construction Review Findings notes here</mat-label>
          <textarea matInput
            [formControl]="review"
          (change)="reviewChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>

  <div class="col-md-6">
    <div [ngClass]="permissions.creawebConstructionFieldPermissions._edit ? 'subsection-header-with-button' : 'subsection-header'"  class="gray">
      @if (permissions.creawebConstructionFieldPermissions._edit) {
        <span></span>
      }
      Environmental Review Findings
      @if (permissions.creawebConstructionFieldPermissions._edit) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleEnvEditMode()">
            @if (!envEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (envEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    @if (!permissions.creawebConstructionFieldPermissions._edit || !envEditMode) {
      <div>
        @if (envReview !== '') {
          <div class="notes-read-only">{{envReview}}</div>
        }
        @if (envReview === '') {
          <em>There are no Environmental Review Findings for this deal.</em>
        }
      </div>
    }
    @if (permissions.creawebConstructionFieldPermissions._edit && envEditMode) {
      <form>
        <mat-form-field>
          <mat-label>Type Environmental Review Findings notes here</mat-label>
          <textarea matInput
            [formControl]="env"
          (change)="envChanged=true"></textarea>
        </mat-form-field>
      </form>
    }
  </div>
</div>
